import { Fade } from "@mui/material";
import styles from "../../content/pages/homepage.module.css";
import { Box } from "@mui/system";
import { useContext, useEffect, useState } from "react";
import { WidgetContext } from "src/contexts/WidgetContext";
import Drawer from "@mui/material/Drawer";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";
// import WaiverResponse from "./WaiverResponse";
import { isIOS, isAndroid } from "../../utils/platformUtils";
// import WaiverResponseStream from "./WaiverResponseStream";
import { trackFeatureTimeSpent } from "src/utils/analyticsCapFirebase";
import { useAuth0 } from "@auth0/auth0-react";
import ChatBotResponseStream from "./ChatBotResponseStream";
import { audioService } from "src/services/audioService";

function ChatBotList({ onClose, setShouldPlayAudio, autoStartRecording, updateCreditsAfterEndpoint, setIsBenchDrawerOpen, setIsPaymentOpen, setInitialPaymentView, userSubscription, isCreditsAnimating, creditsBoxRef }) {
  // import function of WidgetContext
  const { isDrawerOpen, selectedPartner, setIsDrawerOpen, setSelectedPartner, selectedTeamInfo, NON_LOGGED_IN_CONFIG, aiSettings } = useContext(WidgetContext);
  const { user } = useAuth0();
  // Track when drawer opens
  const [drawerOpenTime, setDrawerOpenTime] = useState<number | null>(null);

  // Track drawer open time
  useEffect(() => {
    if (isDrawerOpen && !drawerOpenTime) {
      setDrawerOpenTime(Date.now());
    }
  }, [isDrawerOpen, drawerOpenTime]);

  // Stop any playing audio (welcome, funny, etc.) when chatbot drawer opens
  useEffect(() => {
    if (isDrawerOpen) {
      // Stop current audio to give priority to chatbot
      audioService.stopCurrentAudio();
    }
  }, [isDrawerOpen]);

  const handleClose = () => {
    // Calculate time spent if drawer was open
    if (drawerOpenTime) {
      const timeSpentMs = Date.now() - drawerOpenTime;
      const timeSpentSeconds = Math.round(timeSpentMs / 1000);

      // Get current platform/team info from context or props
      const currentPlatform = selectedTeamInfo?.platformId || "unknown";

      const authId = user?.sub ?? NON_LOGGED_IN_CONFIG?.NON_LOGGED_IN_AUTH_ID ?? "unknown";
      // console.log("currentlatform WAIVER", currentPlatform);

      // Track the time spent
      if (timeSpentSeconds > 0) {
        trackFeatureTimeSpent(authId, "chatbot", timeSpentSeconds, currentPlatform);
      }
      // Reset timer
      setDrawerOpenTime(null);
    }
    // if (waiverAudioRef?.current) {
    //   waiverAudioRef?.current?.pause();
    //   // waiverAudioRef.current.currentTime = 0; // Reset audio to the beginning for next time.
    // }
    // Reset the shouldPlayAudio state to false
    setShouldPlayAudio(false);
    // Sync close: onClose clears thoughts + closes drawer (avoids sign flash before clear)
    onClose();
  };

  return (
    <>
      <Drawer
        anchor="bottom"
        open={isDrawerOpen}
        // onClose={handleClose}
        // onOpen={() => setIsDrawerOpen(true)}
        hideBackdrop={true}
        sx={{
          pointerEvents: "none", // Add this - makes the entire drawer container non-interactive
        }}
        ModalProps={{
          keepMounted: true,
          // No cubrir la barra superior: safe-area + 56px (misma cifra que restas en height)
          sx: {
            pointerEvents: "auto", // Block background scroll when drawer is open
            top: isIOS || isAndroid ? "calc(env(safe-area-inset-top) + 56px)" : "56px",
            zIndex: 1440,
          },
        }}
        PaperProps={{
          sx: {
            width: {
              xs: "100%",
              sm: "720px",
              md: "720px",
              lg: "720px",
            },
            margin: {
              xs: "0",
              sm: "0 auto",
              md: "0 auto",
              lg: "0 auto",
            },
            // height: isIOS || isAndroid ? "calc(100svh - env(safe-area-inset-top) - 56px)" : "calc(100vh  - 56px)",
            height: isIOS || isAndroid
              ? (aiSettings.quan ? "calc(100svh - env(safe-area-inset-top))" : "calc(100svh - env(safe-area-inset-top) - 56px)")
              : (!aiSettings.quan ? "calc(100vh - 56px)" : "100%"), border: `1px solid ${PureLightThemeCaaS.colors.alpha.white[30]}`,
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
          },
        }}
      >
        {/* <Fade in={isDrawerOpen} timeout={700}> */}
        <Box
          className={styles.noScrollbar}
          sx={{
            bgcolor: `${PureLightThemeCaaS.colors.alpha.black[100]}`,
            height: "100%",
            // overflow: "hidden",
            position: "relative",
            touchAction: "none", //Prevent scroll of the parent container
            "& > *": {
              touchAction: "pan-y", //Allow scroll only in child components
            },
            // ADD THIS LINE to respect the bottom safe area on all devices
            paddingBottom: isAndroid ? "max(env(safe-area-inset-bottom), 15px)" : "0px",
            pointerEvents: "auto", // Add this - re-enables interaction inside the drawer
          }}
        >
          {selectedPartner && (
            <ChatBotResponseStream
              onClose={handleClose}
              autoStartRecording={autoStartRecording}
              isDrawerOpen={isDrawerOpen}
              updateCreditsAfterEndpoint={updateCreditsAfterEndpoint}
              setIsBenchDrawerOpen={setIsBenchDrawerOpen}
              setIsPaymentOpen={setIsPaymentOpen}
              setInitialPaymentView={setInitialPaymentView}
              userSubscription={userSubscription}
              isCreditsAnimating={isCreditsAnimating}
              creditsBoxRef={creditsBoxRef}
            />
          )}
        </Box>
        {/* </Fade> */}
      </Drawer>
    </>
  );
}

export default ChatBotList;
